import React, { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  Heading,
  NavbarContent,
  Box,
  NavbarCollapse,
  Textfield,
  DynamicIcon,
  NavbarToggle,
} from "legion-ui";

const NavigationSearch = () => {
  const [activeToggle, setActiveToggle] = useState(false);

  return (
    <Navbar variant="sticky" mode="light">
      <NavbarBrand style={{ display: "flex", alignItem: "center" }}>
        <Heading size="h3" color="primary500">
          Legion
        </Heading>
        <NavbarContent>
          <div className="boxtextfield" style={{ width: 250 }}>
            <Textfield
              iconLeft={<DynamicIcon name="Search" />}
              placeholder="Search"
            />
          </div>
        </NavbarContent>
        <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
      </NavbarBrand>
      <NavbarCollapse isActive={activeToggle}>
        <Box>
          <div className="boxtextfield" style={{ width: 250 }}>
            <Textfield
              iconLeft={<DynamicIcon name="Search" />}
              placeholder="Search"
            />
          </div>
        </Box>
      </NavbarCollapse>
    </Navbar>
  );
};

export default NavigationSearch;
